import { useSelector } from "react-redux";

import { TotalsLine } from "components/formFields/Totals/TotalsLine";

import { formatMoneyValueFixedDigits } from "services/utility/formatting";

export function LineItemTotals(props) {
  const { value, label } = props;

  const currencyMinimumFractionDigits = useSelector(
    (state) =>
      state.userCompanySettings.localization.currencyMinimumFractionDigits
  );

  const localizedTotal = formatMoneyValueFixedDigits(
    value,
    currencyMinimumFractionDigits
  );

  return <TotalsLine label={label} value={localizedTotal} />;
}
